/**
 * Putt Broadie Drill 100FT Reducers
 */
import {
    PUTTBDHUNDREDPOINTS_ACTION,
    ALL_PUTTBDHUNDREDPOINTS,
    ADD_PUTTBDHUNDREDPOINTS,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    puttbdhundredpointlist:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case PUTTBDHUNDREDPOINTS_ACTION:
            return { ...state, loading: true };       

        case ALL_PUTTBDHUNDREDPOINTS:
            return { ...state, loading: false, puttbdhundredpointlist: action.payload };     
            
        case ADD_PUTTBDHUNDREDPOINTS:
            return { ...state, loading: false };             
        
        default: return { ...state };

     }
 }